module.exports = {
    title: "இலகுவழியில் programming கற்போம்",
    slug: "programming",
    description:
      "",
    videos: [
      {
        id: 1,
        title: "இலகுவழியில் programming கற்போம் - அறிமுகம்",
        link: "https://www.youtube.com/embed/TSFjyng_d3Y",
      },
      {
        id: 2,
        title:
          "Programming கற்போம் - Installation மற்றும் Hello World",
        link: "https://www.youtube.com/embed/xzJWU8dXWUg",
      },
      {
        id: 3,
        title: "Programming கற்போம் - அறிமுகம் - பகுதி 1",
        link: "https://www.youtube.com/embed/OVEGSy-aNCE",
      },
    ],
  }
  